/* ============ AMOUR — shared behaviours (Shopify) ============ */
(function () {
  var ROUTES = window.AMOUR_ROUTES || { cart_add: '/cart/add.js', cart: '/cart.js', cart_change: '/cart/change.js' };

  /* ---- marquee ---- */
  var mqEl = document.getElementById('mq');
  if (mqEl && mqEl.dataset.msgs) {
    var msgs = mqEl.dataset.msgs.split('|').filter(Boolean);
    var h = '';
    for (var r = 0; r < 2; r++) msgs.forEach(function (m) { h += '<span>' + m.trim() + '</span>'; });
    mqEl.innerHTML = h;
  }

  /* ---- toast ---- */
  var toastEl = document.getElementById('toast'), toastT;
  window.toast = function (msg) {
    if (!toastEl) return;
    document.getElementById('toastMsg').textContent = msg;
    toastEl.classList.add('show'); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  };

  /* ---- money formatting ---- */
  function moneyFmt(cents) {
    var f = window.AMOUR_MONEY_FORMAT || '${{amount}}';
    if (cents == null || isNaN(cents)) cents = 0;
    // Use the active market currency (e.g. EUR for NL shoppers) so the symbol/format
    // matches what Shopify converted the price to. Falls back to the base money format.
    var active = window.AMOUR_CURRENCY || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
    if (active) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: active }).format(cents / 100); }
      catch (e) { /* unknown currency code — fall back to base format below */ }
    }
    function fmt(precision, thousands, decimal) {
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, t) {
      switch (t) {
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        default: return fmt(2, ',', '.');
      }
    });
  }
  window.amourMoney = moneyFmt;

  /* ---- cart drawer ---- */
  var drawer = document.getElementById('cartDrawer');
  var FREE_SHIP = window.AMOUR_FREESHIP || 0; /* cents; 0 = disabled */

  function setCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      try { el.animate([{ transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 260 }); } catch (e) {}
    });
  }

  function cartRow(item) {
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<div class="cd-variant">' + item.variant_title + '</div>' : '';
    var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
    return '<div class="cd-item" data-key="' + item.key + '">' +
        '<a class="cd-img" href="' + item.url + '">' + img + '</a>' +
        '<div class="cd-mid">' +
          '<a class="cd-name" href="' + item.url + '">' + item.product_title + '</a>' + variant +
          '<div class="cd-qty">' +
            '<button type="button" data-act="dec" aria-label="Decrease">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-act="inc" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd-end">' +
          '<div class="cd-price">' + moneyFmt(item.final_line_price) + '</div>' +
          '<button class="cd-remove" type="button" data-act="remove">Remove</button>' +
        '</div>' +
      '</div>';
  }

  function freeShipHtml(total) {
    if (!FREE_SHIP) return '';
    if (total >= FREE_SHIP) {
      return '<div class="cd-ship unlocked"><div class="cd-ship-msg">✓ You’ve unlocked <b>free shipping</b>!</div><div class="cd-ship-bar"><i style="width:100%"></i></div></div>';
    }
    var pct = Math.max(5, Math.round(total / FREE_SHIP * 100));
    return '<div class="cd-ship"><div class="cd-ship-msg">You’re <b>' + moneyFmt(FREE_SHIP - total) + '</b> away from free shipping</div><div class="cd-ship-bar"><i style="width:' + pct + '%"></i></div></div>';
  }

  function renderCart(cart) {
    setCounts(cart.item_count);
    if (!drawer) return;
    var itemsEl = drawer.querySelector('#cdItems');
    var footEl = drawer.querySelector('#cdFoot');
    var shipEl = drawer.querySelector('#cdShip');
    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="cd-empty"><div class="cd-empty-emoji">🛍️</div><p>Your bag is empty</p><span>Go treat yourself — it’s all waterproof &amp; made to live on you.</span><button type="button" class="btn btn-primary" onclick="closeCart()">Start shopping</button></div>';
      if (shipEl) shipEl.innerHTML = '';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    itemsEl.innerHTML = cart.items.map(cartRow).join('');
    if (shipEl) shipEl.innerHTML = freeShipHtml(cart.total_price);
    if (footEl) {
      footEl.style.display = '';
      var sub = drawer.querySelector('#cdSubtotal');
      if (sub) sub.innerHTML = moneyFmt(cart.total_price);
    }
  }

  function fetchAndRenderCart(open) {
    return fetch(ROUTES.cart + '?_=' + Date.now(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (open) window.openCart(); return c; })
      .catch(function () {});
  }
  window.refreshCart = fetchAndRenderCart;

  window.openCart = function () { if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; } };
  window.closeCart = function () { if (drawer) { drawer.classList.remove('open'); document.body.style.overflow = ''; } };

  function changeCart(key, qty) {
    fetch(ROUTES.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); }).catch(function () {});
  }

  if (drawer) {
    var cdItems = drawer.querySelector('#cdItems');
    if (cdItems) cdItems.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]');
      if (!btn) return;
      var row = btn.closest('.cd-item'); if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyEl = row.querySelector('.cd-qty span');
      var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var act = btn.getAttribute('data-act');
      if (act === 'inc') changeCart(key, cur + 1);
      else if (act === 'dec') changeCart(key, Math.max(0, cur - 1));
      else if (act === 'remove') changeCart(key, 0);
    });
  }

  fetchAndRenderCart(false);

  /* ---- add to cart (AJAX) ---- */
  window.amourAdd = function (variantId, qty, label, silent) {
    if (!variantId) { window.toast('Pick an option first'); return Promise.reject(); }
    // Open the drawer instantly (showing current items) so it feels snappy,
    // then refresh contents once the add request returns — no waiting on 2 fetches.
    if (!silent) window.openCart();
    return fetch(ROUTES.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { window.toast(res.d.description || 'Could not add to bag'); throw res.d; }
        return fetchAndRenderCart(false);
      });
  };

  /* quick-add buttons on product cards */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault(); e.stopPropagation();
      window.amourAdd(q.getAttribute('data-variant-id'), 1, q.getAttribute('data-name'));
      return;
    }
    var w = e.target.closest('.wish');
    if (w) { e.preventDefault(); e.stopPropagation(); w.classList.toggle('on'); }
  });

  /* cart icon opens the drawer */
  var cb = document.getElementById('cartBtn');
  if (cb) cb.addEventListener('click', function (e) { e.preventDefault(); fetchAndRenderCart(true); });

  /* ============ SHOP BY LOOK MODAL ============ */
  window.openLook = function (i) {
    var data = window.AMOUR_LOOKS && window.AMOUR_LOOKS[i];
    var modal = document.getElementById('lookModal');
    if (!data || !modal) return;
    document.getElementById('modalTitle').textContent = data.title;
    document.getElementById('modalSub').textContent = data.items.length + ' pieces in this look';
    var reel = document.getElementById('modalReel');
    var media, hasVideo = false;
    if (data.video) {
      hasVideo = true;
      media = '<video class="fill-img reel-vid" autoplay muted loop playsinline preload="auto"' + (data.image ? ' poster="' + data.image + '"' : '') + ' src="' + data.video + '"></video>';
    } else if (data.embed) {
      hasVideo = true;
      media = '<iframe class="reel-frame" title="' + (data.title || 'Reel') + '" src="' + data.embed + '" allow="autoplay; encrypted-media; picture-in-picture" frameborder="0"></iframe>';
    } else if (data.image) {
      media = '<img class="fill-img" src="' + data.image + '" alt="">';
    } else {
      media = '<div class="ph" data-label="' + (data.label || '') + '"></div>';
    }
    reel.innerHTML = media + (hasVideo ? '' : '<div class="pulse" style="top:34%;left:46%"></div><div class="pulse" style="top:58%;left:38%"></div>');
    document.getElementById('modalProducts').innerHTML = data.items.map(function (it) {
      return '<div class="lp">' +
        '<div class="thumb">' + (it.image ? '<img class="fill-img" src="' + it.image + '" alt="">' : '') + '</div>' +
        '<div class="d"><div class="n">' + it.title + '</div><div class="p">' + it.price + '</div></div>' +
        '<button class="add" data-quick-add data-variant-id="' + it.variantId + '" data-name="' + it.title + '">+</button>' +
        '</div>';
    }).join('');
    window.__currentLook = i;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeLook = function () {
    var modal = document.getElementById('lookModal');
    if (modal) modal.classList.remove('open');
    document.body.style.overflow = '';
  };
  window.addAllLook = function () {
    var data = window.AMOUR_LOOKS && window.AMOUR_LOOKS[window.__currentLook];
    if (!data) return;
    var items = data.items.filter(function (it) { return it.variantId; })
      .map(function (it) { return { id: Number(it.variantId), quantity: 1 }; });
    if (!items.length) { window.toast('Add pieces to this look in the editor'); return; }
    fetch(ROUTES.cart_add, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () { window.closeLook(); fetchAndRenderCart(true); });
  };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { window.closeLook(); window.closeCart(); } });

  /* mobile filter toggle */
  window.toggleFilters = function () {
    var f = document.getElementById('filters');
    if (f) f.classList.toggle('open');
  };

  /* ============ SEARCH MODAL ============ */
  var sModal = document.getElementById('searchModal');
  var sInput = document.getElementById('searchInput');
  var sDefault = document.getElementById('searchDefault');
  var sResults = document.getElementById('searchResults');
  var sBtn = document.getElementById('searchBtn');
  var sDebounce;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  window.openSearch = function () {
    if (!sModal) return;
    sModal.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (sInput) sInput.focus(); }, 60);
  };
  window.closeSearch = function () {
    if (!sModal) return;
    sModal.classList.remove('open');
    document.body.style.overflow = '';
  };
  if (sBtn) sBtn.addEventListener('click', function (e) { e.preventDefault(); window.openSearch(); });

  if (sModal) {
    sModal.querySelectorAll('.search-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-tab');
        sModal.querySelectorAll('.search-tab').forEach(function (x) { x.classList.toggle('active', x === t); });
        sModal.querySelectorAll('.search-tabpanel').forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-tab') === key); });
      });
    });
  }

  function sRow(item) {
    return '<a class="sres" href="' + esc(item.url || '#') + '">' +
      '<span class="sres-img"><img src="' + esc(item.image || '') + '" alt="" loading="lazy" onerror="this.onerror=null;this.src=\'https://loremflickr.com/160/160/jewelry?lock=410\'"></span>' +
      '<span class="sres-d"><span class="sres-n">' + esc(item.title) + '</span><span class="sres-p">' + esc(item.price || '') + '</span></span></a>';
  }

  function filterDemo(q) {
    var list = window.AMOUR_SEARCH_DEMO || [];
    q = q.toLowerCase();
    return list.filter(function (p) { return (p.title + ' ' + (p.type || '')).toLowerCase().indexOf(q) !== -1; });
  }

  function moneyFromSuggest(v) {
    if (v == null || v === '') return '';
    // suggest.json returns the price in MAJOR units (e.g. "79.90", or "55.01" in EUR).
    // Format it through the currency-aware helper so it shows the right symbol/format.
    var n = typeof v === 'number' ? v : parseFloat(String(v).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return '';
    return window.amourMoney ? window.amourMoney(Math.round(n * 100)) : '$' + n.toFixed(2);
  }

  function renderSResults(items, q) {
    if (!sResults) return;
    if (!items.length) {
      sResults.innerHTML = '<div class="sempty">No matches for &ldquo;' + esc(q) + '&rdquo;. Try &ldquo;ring&rdquo;, &ldquo;hoops&rdquo; or &ldquo;chain&rdquo;.</div>';
      return;
    }
    var chips = items.slice(0, 5).map(function (it) {
      return '<button class="sug-chip" type="button" data-q="' + esc(it.title) + '">' + esc(it.title) + '</button>';
    }).join('');
    var rows = items.slice(0, 8).map(sRow).join('');
    sResults.innerHTML = '<div class="sug-chips">' + chips + '</div>' +
      '<div class="sres-head">Products</div>' +
      '<div class="sres-list">' + rows + '</div>' +
      '<a class="sres-all btn btn-ink" href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
    sResults.querySelectorAll('.sug-chip').forEach(function (c) {
      c.addEventListener('click', function () { sInput.value = c.getAttribute('data-q'); runSearch(); });
    });
  }

  function runSearch() {
    if (!sInput) return;
    var q = (sInput.value || '').trim();
    if (q.length < 1) {
      if (sDefault) sDefault.style.display = '';
      if (sResults) { sResults.style.display = 'none'; sResults.innerHTML = ''; }
      return;
    }
    if (sDefault) sDefault.style.display = 'none';
    if (sResults) sResults.style.display = '';
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (((data.resources || {}).results || {}).products) || [];
        if (prods.length) {
          renderSResults(prods.map(function (p) {
            return { title: p.title, url: p.url, price: moneyFromSuggest(p.price), image: (p.featured_image && p.featured_image.url) || p.image || '' };
          }), q);
        } else {
          renderSResults(filterDemo(q), q);
        }
      })
      .catch(function () { renderSResults(filterDemo(q), q); });
  }

  if (sInput) {
    sInput.addEventListener('input', function () { clearTimeout(sDebounce); sDebounce = setTimeout(runSearch, 180); });
    sInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var q = (sInput.value || '').trim(); if (q) window.location.href = '/search?q=' + encodeURIComponent(q); }
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.closeSearch(); });

  /* ============ SOCIAL PROOF — recent buyer popups ============ */
  var spPop = document.getElementById('spPop');
  if (spPop) {
    var SP_INT = (parseInt(spPop.getAttribute('data-interval'), 10) || 5) * 1000;
    var spNames = ['Sanne', 'Femke', 'Lotte', 'Noa', 'Julia', 'Emma', 'Sophie', 'Eva', 'Anouk', 'Lieke', 'Isa', 'Tess', 'Fleur', 'Saar', 'Mila', 'Yara', 'Roos', 'Sara'];
    var spSur = ['de Vries', 'Bakker', 'Jansen', 'Visser', 'Smit', 'Meijer', 'Mulder', 'de Boer', 'Bos', 'Vos', 'van Dijk', 'Peeters', 'de Jong', 'van den Berg'];
    var spPlaces = ['Amsterdam, NL', 'Rotterdam, NL', 'Utrecht, NL', 'The Hague, NL', 'Eindhoven, NL', 'Groningen, NL', 'Haarlem, NL', 'Tilburg, NL', 'Breda, NL', 'Nijmegen, NL', 'Delft, NL', 'Leiden, NL', 'Maastricht, NL', 'Almere, NL', 'Antwerp, BE', 'Brussels, BE', 'Paris, FR', 'Berlin, DE', 'Copenhagen, DK'];
    var spProducts = window.AMOUR_SP_PRODUCTS || [];
    function spRand(a) { return a[Math.floor(Math.random() * a.length)]; }
    var spName = document.getElementById('spName'), spCity = document.getElementById('spCity'),
        spProd = document.getElementById('spProd'), spTime = document.getElementById('spTime'),
        spImg = document.getElementById('spImg'), spLink = spPop.querySelector('.sp-link');
    var spTimer, spHide;
    function spShow() {
      if (!spProducts.length) return;
      var p = spRand(spProducts);
      spName.textContent = spRand(spNames) + ' ' + spRand(spSur);
      spCity.textContent = spRand(spPlaces);
      spProd.textContent = p.title;
      spTime.textContent = (Math.floor(Math.random() * 57) + 2) + ' minutes ago';
      if (spImg) spImg.src = p.image || '';
      if (spLink) spLink.href = p.url || '#';
      spPop.classList.add('show');
      clearTimeout(spHide);
      spHide = setTimeout(function () { spPop.classList.remove('show'); }, Math.max(2600, SP_INT - 1200));
    }
    var spX = spPop.querySelector('.sp-x');
    if (spX) spX.addEventListener('click', function () { spPop.classList.remove('show'); clearInterval(spTimer); });
    setTimeout(function () { spShow(); spTimer = setInterval(spShow, SP_INT); }, 3000);
  }
})();
